import React from 'react'
import "./about.css"
import ME from "../../assets/me-about.png"
import {RiAwardLine} from "react-icons/ri"
import {FaUsers} from "react-icons/fa"
import {MdOutlineLibraryBooks} from "react-icons/md"

const About = () => {
  return (
    <section id="about">
    <h5> Get to Know </h5>
    <h2> About Me </h2>

    <div className ="container about__container ">
     <div className = "about__me">
      <div className="about__me-image"> 
       <img src={ME}></img>
      </div>
     </div>

     <div className="about__content">
      <div className ="about__cards">
        <article className="about__card">
         <RiAwardLine className="about__icon"/>
          <h5> Experience </h5>
          <small> Fresher  </small>
        </article>
        <article className="about__card">
         <FaUsers className="about__icon"/>
          <h5> Clients </h5>
          <small> 3   </small>
        </article>
        <article className="about__card">
         <MdOutlineLibraryBooks className="about__icon"/>
          <h5> Projects  </h5>
          <small> 10+  </small>
        </article>
      </div>
      <p>Hello! Good to see you here. I am 26 years old life sciences post graduate. Actively looking to get my hands on latest Web development technologies.</p>

      <p> I am sure to develop something that solves a problem for you in future.</p>
      
       
      <a href="#contact" className="btn btn-primary">Let's connect</a>
     </div>

    </div>
    </section>
    
  )
}

export default About